
(function inicioControllerDefinition() {

    'use strict';

    angular.module('Inicio')
        .controller('InicioController', ['auth',
            'authExtend', '$scope', 'config', '$state', '$translate', '$stateParams', 'alerts', 'loginService', 'errorsExtend', 'adminUserService', 'login', 'storageService', 'documentsShortcutsService', 'documentContainersShortcutsService', '$q', 'documentService', 'documentTypeService', 'fileService', 'fileDownloader', 'documentContainerService', 'containerTypeService', '$location', 'documentAction', 'documentContainerAction', 'favoritesService', 'documentAndContainerFindService', 'workspaceService', '$filter',
            function inicioController(auth, authExtend, $scope, config, $state, $translate, $stateParams, alerts, loginService, errors, adminUserService, login, storageService, documentsShortcutsService, documentContainersShortcutsService, $q, documentService, documentTypeService, fileService, fileDownloader, documentContainerService, containerTypeService, $location, documentAction, documentContainerAction, favoritesService, documentAndContainerFindService, workspaceService, $filter) {
                $scope.homeTitle = config.homeTitle();
                $scope.homeText = config.homeText();
                $scope.logoSrc = 'app/views/inicio/LogoEDRT.png';
                $scope.documentRead = authExtend.isInRole('DOCUMENT READ');
                $scope.documentContainerRead = authExtend.isInRole('DOCUMENTCONTAINER READ');
                $scope.documentWrite = authExtend.isInRole('DOCUMENT WRITE') || authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                $scope.documentContainerWrite = authExtend.isInRole('DOCUMENTCONTAINER WRITE');
                $scope.isImpersonated = authExtend.getOrganizationId() !== '';
                $scope.userId = authExtend.getUserId();
                $scope.docsAndContsSearched = false;
                $scope.searched = false;
                $scope.isLogged = auth.isLogged();
                $scope.imageStartUrl = auth.getUrlStartImage();
                $scope.gridHeaderClassName = '';

                $scope.showForm = false;

                if ($location.search().t) {
                    if (auth.changeApp($location.search().t)) {
                        $scope.showForm = false;
                    }
                }

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationFirstFem', 'PaginationLastFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                $scope.showForm = true;

                $scope.find = storageService.getSearchBarFilter();

                $scope.dataDocument = {
                    grid: { documents: [], valuesCount: 0 },
                    data: { totalItems: 0, currentPage: 1, itemsPerPage: 15, maxPage: 0, hasItems: function (list) { return $scope.dataDocument.data.totalItems > 0; } },
                    sortedBy: { asc: true, header: 'name', headerIndex: 1 }
                };

                $scope.docGrid = { documents: [], valuesCount: 0 };
                $scope.docSortedBy = { asc: true, header: 'name', headerIndex: 1 };
                $scope.docData = { totalItems: 0, currentPage: 1, itemsPerPage: 15, maxPage: 0, hasItems: function (list) { return $scope.docData.totalItems > 0; } };

                $scope.dataFolder = {
                    grid: { documents: [], valuesCount: 0 },
                    data: { totalItems: 0, currentPage: 1, itemsPerPage: 15, maxPage: 0, hasItems: function (list) { return $scope.dataFolder.data.totalItems > 0; } },
                    sortedBy: { documents: [], valuesCount: 0 }
                };

                $scope.advDocGrid = { documents: [], valuesCount: 0, sortableHeaders: [] };
                $scope.advDocSortedBy = { asc: true, header: 'name', headerIndex: 1 };
                $scope.advDocData = { totalItems: 0, itemsPerPage: 15, maxPage: 0, hasItems: function (list) { return $scope.advDocData.totalItems > 0; } };

                $scope.advDocData.currentPage = $scope.find.currentPage != undefined ? $scope.find.currentPage : 1;

                $scope.dataMyWorkspace = {
                    grid: { documents: [], valuesCount: 0 },
                    data: { totalItems: 0, currentPage: 1, itemsPerPage: 15, maxPage: 0, hasItems: function (list) { return $scope.dataMyWorkspace.data.totalItems > 0; } },
                    sortedBy: { asc: true, header: 'name', orderBy: 'Name ASC' }
                };

                $scope.myWorkspaceGrid = { documents: [], valuesCount: 0 };
                $scope.myWorkspaceSortedBy = { asc: true, header: 'Name ASC', headerName: 'Name' };
                $scope.myWorwkspaceData = { totalItems: 0, currentPage: 1, itemsPerPage: 15, maxPage: 0, hasItems: function (list) { return $scope.myWorwkspaceData.totalItems > 0; } };

                $scope.aux = {
                    activeGrids: 0,
                    activeGrid: ''
                };

                if (config.singleSignOn()) {
                    if (!auth.isLogged()) {
                        auth.loginIntegrated().then(function () {
                            $scope.loggingIn = false;

                            if (auth.isLogged()) {
                                if (authExtend.getUserId() === '') {
                                    adminUserService.getWindowsAuthenticatedUser(auth.getUserName()).then(function (result) {
                                        if (result === null) {
                                            var params = {
                                                userName: auth.getUserName(),
                                                password: ""
                                            };

                                            $state.go('user-add-new', params);
                                        }
                                    }, function (error) {
                                        errors.showError(error);
                                    });
                                }
                            }
                        }, function (data) {
                            $scope.loginFailed = true;
                            $scope.loggingIn = false;
                        });
                    }
                    else {
                        $scope.loggingIn = false;
                    }
                }

                auth.onIdentityChanged(function identityChangedFn() {
                    $scope.documentRead = authExtend.isInRole('DOCUMENT READ');
                    $scope.documentContainerRead = authExtend.isInRole('DOCUMENTCONTAINER READ');
                    $scope.documentWrite = authExtend.isInRole('DOCUMENT WRITE') || authExtend.isInRole('DOCUMENTVERSIONED WRITE');
                    $scope.documentContainerWrite = authExtend.isInRole('DOCUMENTCONTAINER WRITE');
                    $scope.isImpersonated = authExtend.getOrganizationId() !== '';
                    $scope.find.name = '';
                    $scope.searched = false;
                    $scope.docsAndContsSearched = false;
                    $scope.isLogged = auth.isLogged();

                    $scope.loginFailed = !$scope.isLogged;

                    $scope.imageStartUrl = auth.getUrlStartImage();

                    if (!$scope.imageStartUrl) {
                        $scope.imageStartUrl = 'app/views/inicio/inicio.jpg';
                    }

                    $scope.dataDocument.grid = {
                        documents: [],
                        valuesCount: 0
                    };

                    $scope.dataFolder.grid = {
                        documents: [],
                        valuesCount: 0
                    };

                    $scope.dataDocument.data.totalItems = 0;
                    $scope.dataFolder.data.totalItems = 0;

                    if ($scope.isLogged) {
                        $scope.searchMyWorkspace();
                    }

                    $scope.advDocGrid = { documents: [], valuesCount: 0, sortableHeaders: [] };
                    $scope.advDocData = { totalItems: 0, itemsPerPage: 15, maxPage: 0, hasItems: function (list) { return $scope.advDocData.totalItems > 0; } };
                    $scope.gridHeaderClassName = '';


                });

                if (!$scope.imageStartUrl) {
                    $scope.imageStartUrl = 'app/views/inicio/inicio.jpg';
                }

                $scope.changeUser = function () {
                    if (!$stateParams.key || !auth.isLogged()) {
                        return;
                    }
                    else {
                        loginService.setUser($stateParams.key).then(function (result) {

                            auth.refreshToken().then(function (result) {
                                if (!result) {
                                    login.logOut();
                                    return;
                                }
                            },
                                function () {
                                    login.logOut();
                                });
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.loginResult = function (result) {
                    if (result && auth.getMustChangePassword()) {
                        $state.go('change-password');
                        return false;
                    }
                    if (result && auth.getHasPendingNotifications()) {
                        $state.go('notification-popup');
                        return false;
                    }

                    return result;
                };

                $scope.changePage = function () {
                    $scope.find.currentPage = $scope.advDocData.currentPage;
                    storageService.setSearchBarFilter($scope.find);
                    $scope.search();
                }


                $scope.search = function () {
                    $scope.dataDocument.grid.documents = [];
                    $scope.dataFolder.grid.documents = [];
                    $scope.dataDocument.data.totalItems = 0;
                    $scope.advDocData.totalItems = 0;
                    $scope.dataFolder.data.totalItems = 0;

                    if ($scope.find.parameters && $scope.find.parameters.documentTypes) {
                        $scope.searchAdvDocuments();
                    }
                    else {
                        if (($scope.find.name && $scope.find.name.length >= 3) ||
                            ($scope.find.documentIdFilter && $scope.find.documentIdFilter.length >= 1) ||
                            $scope.find.selectedUser.id ||
                            ($scope.find.documentCreationDateFilterFrom && $scope.find.documentCreationDateFilterFrom instanceof Date) ||
                            ($scope.find.documentCreationDateFilterTo && $scope.find.documentCreationDateFilterTo instanceof Date)
                        ) {
                            $scope.gridHeaderClassName = '"' + $scope.find.name + '"';
                            if (!$scope.find.page) {
                                $scope.find.page = 1;
                            }

                            if ($scope.find.page !== $scope.dataDocument.data.currentPage) {
                                $scope.dataDocument.data.currentPage = $scope.find.page;
                            }

                            if ($scope.find.page !== $scope.dataFolder.data.currentPage) {
                                $scope.dataFolder.data.currentPage = $scope.find.page;
                            }

                            var promiseSearchDocuments = $scope.documentRead ? documentsShortcutsService.findShort($scope.find.name, $scope.find.documentIdFilter, ($scope.find.selectedUser) ? $scope.find.selectedUser.id : null, $scope.find.documentCreationDateFilterFrom, $scope.find.documentCreationDateFilterTo, authExtend.getOrganizationId(), $scope.dataDocument.data.currentPage, $scope.dataDocument.data.itemsPerPage, $scope.dataDocument.sortedBy.headerIndex, $scope.dataDocument.sortedBy.asc) : $q.when($scope.documentRead);
                            var promiseSearchFolders = $scope.documentContainerRead ? documentContainersShortcutsService.findShort($scope.find.name, $scope.find.documentIdFilter, ($scope.find.selectedUser) ? $scope.find.selectedUser.id : null, $scope.find.documentCreationDateFilterFrom, $scope.find.documentCreationDateFilterTo, $scope.dataFolder.data.currentPage, $scope.dataFolder.data.itemsPerPage, $scope.dataFolder.sortedBy.headerIndex, $scope.dataFolder.sortedBy.asc) : $q.when($scope.documentContainerRead);

                            $q.all([promiseSearchDocuments, promiseSearchFolders])
                                .then(function (results) {
                                    if (results[0] !== false) {
                                        $scope.dataDocument.grid = results[0];
                                        $scope.dataDocument.data.totalItems = results[0].valuesCount;
                                        $scope.dataDocument.data.maxPage = Math.ceil($scope.dataDocument.data.totalItems / $scope.dataDocument.data.itemsPerPage);
                                        $scope.loadDocumentActions();
                                    }

                                    if (results[1] !== false) {
                                        $scope.dataFolder.grid = results[1];
                                        $scope.dataFolder.data.totalItems = results[1].valuesCount;
                                        $scope.dataFolder.data.maxPage = Math.ceil($scope.dataFolder.data.totalItems / $scope.dataFolder.data.itemsPerPage);
                                        $scope.loadFolderActions();
                                    }

                                    $scope.docsAndContsSearched = true;
                                    $scope.updateActiveGrids();
                                }, function (error) {
                                    errors.showError(error);
                                });
                        }
                    }
                };


                //       *******  DOCUMENTOS BUSQUEDA AVANZADA *********       //

                $scope.loadAdvDocumentActions = function (type) {
                    // guardo la data en cada registro por que cada documento puede ser de distinto type
                    return $scope.advDocGrid.documents.forEach(function (docu) {
                        documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], docu.typeId).then(function (r) { docu.downloadBtn = r; });
                        documentTypeService.isDoctypeInRole(['FILE READ'], docu.typeId).then(function (r) { docu.viewPDFBtn = r; });
                        documentTypeService.isDoctypeInRole(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'], docu.typeId).then(function (r) { docu.canCheckOut = r; });
                        docu.IsCheckedOutByMe = authExtend.getUserId() == docu.documentCheckedOutById;
                        docu.IsCheckedOutByOther = docu.documentCheckedOutById > 0 && !docu.IsCheckedOutByMe;
                        docu.type = type;
                    });
                };

                $scope.searchAdvDocuments = function () {
                    var header = {
                        id: $scope.find.documentIdFilter,
                        createdBy: $scope.find.selectedUser ? $scope.find.selectedUser.id : '',
                        createdDateFrom: $scope.find.documentCreationDateFilterFrom,
                        createdDateTo: $scope.find.documentCreationDateFilterTo,
                        nameType: "Contains",
                        name: $scope.find.name
                    };

                    $scope.docsAndContsSearched = true;
                    $scope.find.filters.header = header;

                    if ($scope.find.classType === 'Documental') {
                        $scope.searchResultType = "SearchDocumentResults";
                        $scope.find.parameters.documentTypes.DocumentTypes.forEach(function (type) {
                            type.Page = $scope.advDocData.currentPage;
                            type.ItemPerPage = $scope.advDocData.itemsPerPage;
                            // Busco el SortHeader para obtener el metadataSystemName
                            var sortBys = $scope.advDocGrid.sortableHeaders.filter(function (h) {
                                return h.value === $scope.advDocSortedBy.header;
                            });

                            if (sortBys.length > 0) {
                                var orderBy = [];
                                orderBy.push(sortBys[0].metadataSystemName);
                                type.OrderBy = orderBy;
                            }
                            // Evitamos la fecha 1900 en los metadatos de busqueda.
                            var dateMetadatas = $filter('filter')(type.metadatas, { metadataType: "date" }, true);
                            angular.forEach(dateMetadatas, function (item) {
                                if (item.metadataValueFrom < '19010101') {
                                    item.metadataValueFrom = null;
                                }

                                if (item.metadataValueTo === '') {
                                    item.metadataValueTo = null;
                                }
                            });
                            type.orderAscendent = $scope.advDocSortedBy.asc;

                        });

                        return documentService.advancedGet($scope.find.parameters).then(function getOk(result) {
                            $scope.advDocGrid.documents = result.values;
                            $scope.advDocData.totalItems = result.valuesCount;
                            $scope.advDocData.maxPage = Math.ceil($scope.advDocData.totalItems / $scope.advDocData.itemsPerPage);
                            $scope.advDocData.class = result.documentTypes[0].name;
                            $scope.advDocData.classId = result.documentTypes[0].id;
                            $scope.advDocGrid.sortableHeaders = result.sortableHeaders;

                            if ($scope.aux.activeGrid !== 'AdvDocuments') {
                                $scope.updateActiveGrids();
                            }

                            $scope.loadAdvDocumentActions('DOCUMENTS');

                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }

                    else if ($scope.find.classType === 'Carpeta') {
                        $scope.searchResultType = "SearchFolderResults";
                        $scope.find.parameters.documentTypes.ContainerTypes.forEach(function (type) {
                            type.Page = $scope.advDocData.currentPage;
                            type.ItemPerPage = $scope.advDocData.itemsPerPage;
                            type.OrderBy = $scope.advDocSortedBy.header;
                            type.orderAscendent = $scope.advDocSortedBy.asc;
                            // Evitamos la fecha 1900 en los metadatos de busqueda.
                            var dateMetadatas = $filter('filter')(type.metadatas, { metadataType: "date" }, true);
                            angular.forEach(dateMetadatas, function (item) {
                                if (item.metadataValueFrom < '19010101') {
                                    item.metadataValueFrom = null;
                                }

                                if (item.metadataValueTo === '') {
                                    item.metadataValueTo = null;
                                }
                            });
                        });

                        return documentContainerService.advancedGet($scope.find.filters).then(function getOk(result) {
                            $scope.advDocGrid.documents = result.values;
                            $scope.advDocData.totalItems = result.valuesCount;
                            $scope.advDocData.maxPage = Math.ceil($scope.advDocData.totalItems / $scope.advDocData.itemsPerPage);
                            $scope.advDocData.class = result.documentTypes[0].name;
                            $scope.advDocGrid.sortableHeaders = result.sortableHeaders;

                            if ($scope.aux.activeGrid !== 'AdvDocuments') {
                                $scope.updateActiveGrids();
                            }

                            $scope.loadAdvDocumentActions('CONTAINERS');
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.sortAdvDocColumn = function (header) {
                    $scope.advDocSortedBy.header = header;
                    $scope.advDocSortedBy.headerIndex = header === 'id' ? 0 : header === 'name' ? 1 : 2;
                    $scope.advDocSortedBy.asc = !$scope.advDocSortedBy.asc;
                    $scope.searchAdvDocuments();
                };

                $scope.advDocPreviousPage = function () {
                    if ($scope.advDocData.currentPage > 1) {
                        $scope.advDocData.currentPage -= 1;
                        $scope.searchAdvDocuments();
                    }
                };

                $scope.advDocNextPage = function () {
                    var maxPage = Math.ceil($scope.advDocData.totalItems / $scope.advDocData.itemsPerPage);

                    if ($scope.advDocData.currentPage < maxPage) {
                        $scope.advDocData.currentPage += 1;
                        $scope.searchAdvDocuments();
                    }
                };

                $scope.goToAdvDocDetail = function (document) {
                    if ($scope.find.classType === 'Documental') {
                        storageService.setStateBackFind('');
                        $scope.goToDocDetail(document);
                    }
                    else if ($scope.find.classType === 'Carpeta') {
                        storageService.setStateBackFind('');
                        $state.go('document-container-detail', { id: document.id });
                    }
                };

                $scope.goToAdvDocView = function (document) {
                    if ($scope.find.classType === 'Documental') {
                        $scope.goToDocView(document);
                    }
                    else if ($scope.find.classType === 'Carpeta') {
                        storageService.setStateBackFind('');
                        $state.go('file-document-container-detail', { id: document.id });

                    }
                };

                $scope.goToView = function (ent) {
                    var stateName;

                    if (ent.type === 'CONTAINERS') {
                        stateName = "file-document-container-detail";
                    } else {
                        stateName = "file-document-detail";
                    }

                    storageService.setStateBackFind('');
                    if (ent.nroVersion) {
                        $state.go(stateName, { id: ent.id, version: ent.nroVersion });
                    } else {
                        $state.go(stateName, { id: ent.id });
                    }

                }

                $scope.goToDetail = function (ent) {
                    var stateName;

                    if (ent.type === 'CONTAINERS') {
                        stateName = 'document-container-detail';
                    } else {
                        if (ent.IsCheckedOutByMe) {
                            stateName = 'mydocument-detail';
                        } else {
                            stateName = 'document-detail';
                        }

                    }


                    storageService.setStateBackFind('');
                    $state.go(stateName, { id: ent.id });
                }

                $scope.goToModify = function (ent) {
                    var stateName;

                    if (ent.type === "CONTAINERS") {
                        stateName = "document-container-modify";
                    } else {
                        stateName = "document-modify";
                    }

                    storageService.setStateBackFind('');
                    $state.go(stateName, { id: ent.id });
                }

                $scope.downloadAdvDocument = function (document) {
                    if ($scope.find.classType === 'Documental') {
                        $scope.downloadDocument(document);
                    }
                };

                $scope.checkIn = function (ent) {
                    if (ent.type === 'CONTAINERS') {
                        documentContainerAction.checkIn(ent).then(function getOk() {
                            ent.IsCheckedOutByMe = false;
                        });
                    } else {
                        return documentAction.checkIn(ent, $scope.advDocData.classId).then(function (doc) {
                            ent.IsCheckedOutByMe = false;
                        });
                    }
                }

                $scope.addFavorite = function (ent, type) {
                    return favoritesService.addFavorite(ent.id, type).then(function getOk(result) {
                        ent.favorited = true;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.checkOutAdvDocument = function (document) {
                    if ($scope.find.classType === 'Documental') {
                        return documentService.checkout(document).then(function () {
                            document.IsCheckedOutByMe = true;
                            errors.showSuccess('DocumentCheckOutSucces');
                        }, function (error) {
                            errors.showError(error);
                        });

                    }
                    else if ($scope.find.classType === 'Carpeta') {
                        return $translate(['Warning', 'DocumentContainerCheckOutConfirmText', 'Yes', 'No'])
                            .then(function (translated) {
                                return alerts.confirm(translated.Warning, translated.DocumentContainerCheckOutConfirmText, translated.Yes, translated.No)
                                    .then(function getOk(result) {
                                        if (!result) {
                                            return result;
                                        }
                                        return documentContainerService.checkout(document)
                                            .then(function getOk(result) {
                                                errors.showSuccess('DocumentContainerCheckOutSucces');
                                                document.IsCheckedOutByMe = true;
                                                $scope.searchMyWorkspace();
                                            }, function (error) {
                                                errors.showError(error);
                                            });
                                    });
                            });

                    }
                };

                //       *******  DOCUMENTOS *********       //
                $scope.loadDocumentActions = function () {
                    // guardo la data en cada registro por que cada documento puede ser de distinto type
                    return $scope.dataDocument.grid.documents.forEach(function (docu) {
                        documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], docu.classId).then(function (r) { docu.canDownload = r; });
                        documentTypeService.isDoctypeInRole(['FILE READ'], docu.classId).then(function (r) { docu.canView = r; });
                        documentTypeService.isDoctypeInRole(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'], docu.classId).then(function (r) {
                            docu.canCheckOut = r;
                            docu.canModify = r;
                        });
                        docu.IsCheckedOutByMe = authExtend.getUserId() === docu.documentCheckedOutById.toString();
                        docu.IsCheckedOutByOther = docu.documentCheckedOutById > 0 && !docu.IsCheckedOutByMe;
                        docu.type = 'DOCUMENTS';
                    });
                };

                $scope.searchDocuments = function () {
                    return documentsShortcutsService.findShort($scope.find.name, $scope.find.documentIdFilter, ($scope.find.selectedUser) ? $scope.find.selectedUser.id : null, $scope.find.documentCreationDateFilterFrom, $scope.find.documentCreationDateFilterTo, authExtend.getOrganizationId(), $scope.dataDocument.data.currentPage, $scope.dataDocument.data.itemsPerPage, $scope.dataDocument.sortedBy.headerIndex, $scope.dataDocument.sortedBy.asc)
                        .then(function (results) {
                            $scope.dataDocument.grid = results;
                            $scope.dataDocument.data.totalItems = results.valuesCount;
                            $scope.dataDocument.data.maxPage = Math.ceil($scope.dataDocument.data.totalItems / $scope.dataDocument.data.itemsPerPage);
                            $scope.loadDocumentActions();
                        }, function (error) {
                            errors.showError(error);
                        });
                };

                $scope.downloadDocument = function (document) {
                    return fileService.downloadFilesDocument(document.id).then(function (result) {

                        var success = fileDownloader.saveAs(result.value, document.name + '.zip');

                        if (!success) {
                            errors.showError('Api failed');
                        }

                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                    });
                };

                $scope.goToDocFind = function () {
                    $state.go('document-advanced-find');
                };


                //       *******  CARPETAS  *********       //
                $scope.loadFolderActions = function () {
                    // guardo la data en cada registro por que cada documento puede ser de distinto type
                    return $scope.dataFolder.grid.documents.forEach(function (cont) {
                        containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER WRITE'], cont.classId).then(function (r) {
                            cont.canCheckOut = r;
                            cont.canModify = r;
                        });
                        containerTypeService.isContainertypeInRole(['FILE DOWNLOAD'], cont.classId).then(function (r) { cont.canDownload = r; });
                        containerTypeService.isContainertypeInRole(['FILE READ'], cont.classId).then(function (r) { cont.canView = r; });
                        cont.IsCheckedOutByMe = authExtend.getUserId() === cont.documentCheckedOutById.toString();
                        cont.IsCheckedOutByOther = cont.documentCheckedOutById > 0 && !cont.IsCheckedOutByMe;
                        cont.type = 'CONTAINERS';
                    });
                };



                $scope.searchFolder = function () {
                    return documentContainersShortcutsService.findShort($scope.find.name, $scope.find.documentIdFilter, ($scope.find.selectedUser) ? $scope.find.selectedUser.id : null, $scope.find.documentCreationDateFilterFrom, $scope.find.documentCreationDateFilterTo, $scope.dataFolder.data.currentPage, $scope.dataFolder.data.itemsPerPage, $scope.dataFolder.sortedBy.headerIndex, $scope.dataFolder.sortedBy.asc)
                        .then(function (results) {
                            $scope.dataFolder.grid = results;
                            $scope.dataFolder.data.totalItems = results.valuesCount;
                            $scope.dataFolder.data.maxPage = Math.ceil($scope.dataFolder.data.totalItems / $scope.dataFolder.data.itemsPerPage);
                            $scope.docsAndContsSearched = true;
                            $scope.loadFolderActions();
                        }, function (error) {
                            errors.showError(error);
                        });
                };

                $scope.goToFolderFind = function () {
                    $state.go('document-container-advanced-find');
                };

                //       *******  MIS ESPACIO DE TRABAJO  *********       //
                // TODO: Acciones de la grilla
                $scope.loadMyWorkspaceActions = function () {
                    // guardo la data en cada registro por que cada documento puede ser de distinto type
                    return $scope.dataMyWorkspace.grid.documents.forEach(function (ent) {
                        ent.canView = true;
                        ent.IsCheckedOutByMe = true;
                        ent.IsCheckedOutByOther = true;
                        if (ent.type === 'DOCUMENTS') {
                            documentTypeService.isDoctypeInRole(['DOCUMENT WRITE', 'DOCUMENTVERSIONED WRITE'], ent.classId).then(function (r) { ent.canModify = r; });
                            documentTypeService.isDoctypeInRole(['FILE DOWNLOAD'], ent.classId).then(function (r) { ent.canDownload = r; });
                        } else {
                            containerTypeService.isContainertypeInRole(['DOCUMENTCONTAINER WRITE'], ent.classId).then(function (r) { ent.canModify = r; });
                            containerTypeService.isContainertypeInRole(['FILE DOWNLOAD'], ent.classId).then(function (r) { ent.canDownload = r; });
                        }
                    });
                };

                $scope.searchMyWorkspace = function () {
                    if (($scope.documentContainerWrite || $scope.documentWrite) && $scope.isImpersonated) {
                        $scope.dataMyWorkspace.grid.documents = [];

                        return workspaceService.getMyWorkspace($scope.dataMyWorkspace.data.currentPage, $scope.dataMyWorkspace.data.itemsPerPage, $scope.dataMyWorkspace.sortedBy.orderBy).then(function getOk(result) {
                            $scope.dataMyWorkspace.grid.documents = result.value;
                            $scope.searched = $scope.dataMyWorkspace.grid.documents.length > 0;
                            $scope.dataMyWorkspace.grid.valuesCount = result.totalCount;
                            $scope.dataMyWorkspace.data.totalItems = result.totalCount;
                            $scope.dataMyWorkspace.data.maxPage = Math.ceil($scope.dataMyWorkspace.data.totalItems / $scope.dataMyWorkspace.data.itemsPerPage);
                            if ($scope.aux.activeGrid !== 'MyWorkspace') {
                                $scope.updateActiveGrids();
                            }

                            $scope.loadMyWorkspaceActions();
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.searchDocsAndConts = function () {
                    if ($scope.documentRead || $scope.documentContainerRead) {
                        $scope.search();
                    }
                };

                $scope.toggleAccordions = function (grid) {
                    $scope.aux.activeGrid = $scope.aux.activeGrid === grid ? '' : grid;
                };

                $scope.updateActiveGrids = function () {
                    $scope.aux.activeGrids = ($scope.dataDocument.data.hasItems() ? 1 : 0) +
                        ($scope.dataFolder.data.hasItems() ? 1 : 0) +
                        ($scope.advDocData.hasItems() ? 1 : 0) +
                        ($scope.dataMyWorkspace.data.hasItems() ? 1 : 0) +
                        ((!$scope.dataDocument.data.hasItems() &&
                            !$scope.dataFolder.data.hasItems() &&
                            $scope.docsAndContsSearched) ? 1 : 0);

                    if ($scope.dataDocument.data.hasItems()) {
                        $scope.aux.activeGrid = 'Documents';
                    }
                    else if ($scope.dataFolder.data.hasItems()) {
                        $scope.aux.activeGrid = 'Folders';
                    }
                    else if ($scope.advDocData.hasItems()) {
                        $scope.aux.activeGrid = 'AdvDocuments';
                    }
                    else if ($scope.dataMyWorkspace.data.hasItems()) {
                        $scope.aux.activeGrid = 'MyWorkspace';
                    }
                };

                $scope.$on('Search-Bar-Menu', function (event, args) {
                    $scope.find = args;
                    $scope.advDocData.currentPage = 1;
                    $scope.find.currentPage = 1;
                    $scope.searchDocsAndConts();
                });

                $scope.downloadContainer = function (docu) {
                    return documentContainerAction.downloadFilesContainer(docu);
                };

                $scope.searchDocsAndConts();
                $scope.searchMyWorkspace();
                $scope.changeUser();
            }
        ]);
})();
